// Copyright 2025, compose-coui-ui contributors
// SPDX-License-Identifier: Apache-2.0
import androidx.compose.animation.core.RepeatMode
import androidx.compose.animation.core.animateFloat
import androidx.compose.animation.core.infiniteRepeatable
import androidx.compose.animation.core.rememberInfiniteTransition
import androidx.compose.animation.core.tween
import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.FlowRow
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.widthIn
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import io.github.suqi8.coui.kmp.basic.CircularProgressIndicator
import io.github.suqi8.coui.kmp.basic.InfiniteProgressIndicator
import io.github.suqi8.coui.kmp.basic.LinearProgressIndicator
import io.github.suqi8.coui.kmp.basic.ProgressIndicatorDefaults
import io.github.suqi8.coui.kmp.basic.RotatingProgressIndicator

@Composable
fun ProgressIndicatorDemo() {
    Box(
        modifier = Modifier
            .fillMaxSize()
            .background(demoBackground()),
        contentAlignment = Alignment.Center,
    ) {
        Column(
            Modifier
                .padding(16.dp)
                .widthIn(max = 600.dp)
                .fillMaxWidth(),
            verticalArrangement = Arrangement.spacedBy(16.dp),
            horizontalAlignment = Alignment.CenterHorizontally,
        ) {
            val progressValues = listOf(0.0f, 0.25f, 0.5f, 0.75f, 1.0f, null)
            val animatedProgressValue by rememberInfiniteTransition().animateFloat(
                initialValue = 0f,
                targetValue = 1f,
                animationSpec = infiniteRepeatable(
                    animation = tween(1000),
                    repeatMode = RepeatMode.Reverse,
                ),
            )
            LinearProgressIndicator(
                progress = animatedProgressValue,
                modifier = Modifier,
            )
            progressValues.forEach { progressValue ->
                LinearProgressIndicator(
                    progress = progressValue,
                    modifier = Modifier,
                )
            }
            FlowRow(
                modifier = Modifier.fillMaxWidth(),
                horizontalArrangement = Arrangement.SpaceEvenly,
            ) {
                CircularProgressIndicator(
                    progress = animatedProgressValue,
                )
                progressValues.forEach { progressValue ->
                    CircularProgressIndicator(
                        progress = progressValue,
                    )
                }
                InfiniteProgressIndicator(
                    modifier = Modifier
                        .align(alignment = Alignment.CenterVertically),
                )
                RotatingProgressIndicator(
                    modifier = Modifier
                        .align(alignment = Alignment.CenterVertically),
                )
                RotatingProgressIndicator(
                    modifier = Modifier
                        .align(alignment = Alignment.CenterVertically),
                    size = ProgressIndicatorDefaults.SmallRotatingProgressIndicatorSize,
                    ringDiameter = ProgressIndicatorDefaults.SmallRotatingProgressIndicatorRingDiameter,
                    strokeWidth = ProgressIndicatorDefaults.SmallRotatingProgressIndicatorStrokeWidth,
                )
            }
        }
    }
}
